import { BudgetExpensesForm } from './BudgetExpensesForm';

export const BudgetOnboardingLifestyleExpenses = () => (
    <BudgetExpensesForm budgetPurpose="lifestyle" />
);
